import React, { useCallback, useEffect, useState } from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import { useTranslation } from 'react-i18next';
import ContainerButton from '../../../components/button/ContainerButton';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckBoxCustom from '../../../components/checkbox/CheckBoxCustom';
import { ButtonContained } from '../../../components/button/ButtonCustoms';
import SettingsIcon from '@mui/icons-material/Settings';
import StateComponents from '../../../components/state-component/StateComponents';
import ModalCustom from '../../../components/modal/ModalCustom';
import { handleTypingNumber } from '../../../utils/app.utils';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { degreeApi } from '../../../api/degree/degree.api';
import { useDispatch } from 'react-redux';
import { CourseOfStudyApi } from '../../../api/course-of-study/course-of-study.api';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { routeName } from '../../../routes/routeName';
import { AcademicYearApi } from '../../../api/academic-year/academic-year.api';
export default function SetTuitionFeesDetail() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { id } = useParams()
    const navigate: NavigateFunction = useNavigate();
    const [detail, setDetail] = useState<any>();

    const [selected, setSelected] = useState<any[]>([])
    // const [data, setData] = useState<any[]>([]);
    const handleGetData = useCallback(async () => {
        let query: any = {

        }
        // if (keyword) query = { ...query, search: keyword }
        // if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        // if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        dispatch(setLoading());
        await degreeApi.tree(query).then((res) => {
            if (res.status < 300) {
                // setData(res.data?.data || []);
                getDetail(res.data?.data)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [])

    const getAcademicYearDetail = async () => {
        await AcademicYearApi.getAcademicYearById(Number(id)).then((res) => {
            if (res.status < 300) {
                setDetail(res.data.data);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        handleGetData()
        getAcademicYearDetail()

    }, [])

    const getDetail = async (data: any) => {
        await CourseOfStudyApi.academicDetailLunch(id).then((res) => {
            if (res.status < 300) {
                const filtered = data
                    .map((degree: any) => {
                        // filter เฉพาะ faculty ที่อยู่ใน b
                        const relatedFaculties = degree.faculty
                            .map((f: any) => {
                                const course = res.data?.data.find((c: any) => c.id_faculty === f.id_faculty);
                                if (course) {
                                    return {
                                        ...f,
                                        id_course_of_study: course.id_course_of_study // เติมเข้าไป
                                    };
                                }
                                return null;
                            })
                            .filter(Boolean);

                        // ถ้ามี faculty ที่ match ก็เก็บ degree ไว้
                        if (relatedFaculties.length > 0) {
                            return {
                                ...degree,
                                faculty: relatedFaculties
                            };
                        }
                        return null;
                    })
                    .filter(Boolean);
                console.log(filtered);
                setSelected(filtered)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    // useEffect(() => {
    //     getDetail()
    // }, [])
    return (
        <div className='w-full'>
            <ContainerLayout
                title={`${t('SET_TUITION_FEES_ACADEMIC_YEAR')} ${detail?.academic_year}`}

                content={
                    <div className='w-full'>

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {selected?.map((item: any) => {
                                return (
                                    <Accordion defaultExpanded sx={{
                                        backgroundColor: "#4A4A4A", color: "white",
                                        // borderRadius: "18px",
                                        overflow: 'hidden'
                                    }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            sx={{
                                                backgroundColor: "#4A4A4A",
                                                padding: "10px 16px",
                                                fontWeight: "bold",
                                                margin: '0px',
                                                "& .MuiAccordionSummary-content": {
                                                    margin: '0px'
                                                },
                                                "& .MuiAccordionSummary-content.Mui-expanded": {
                                                    margin: '0px'
                                                }
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <Typography sx={{ fontWeight: "bold", color: '#fff' }}>{`${item?.degree_name_eng} (${item?.degree_name})`}</Typography>
                                            </Box>

                                        </AccordionSummary>
                                        <AccordionDetails sx={{ backgroundColor: "#fff", color: "black", display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            {item?.faculty?.length > 0 ? item?.faculty?.map((obj: any, i: number) => {
                                                return (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', padding: '10px', justifyContent: 'space-between' }} >
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                            <Typography>{`${obj?.faculty_name_eng} (${obj?.faculty_name})`}</Typography>
                                                        </Box>
                                                        <ButtonContained iconComponent={<SettingsIcon />} buttonName={t('SET_TUITION_FEES_SETUP')} btnProps={{
                                                            bg: '#F79009'
                                                        }} onClick={() => {
                                                            navigate(routeName.admission.CourseTuitionFees?.replace(':id_course_of_study', obj?.id_course_of_study), {
                                                                state: {
                                                                 academic_year: detail?.academic_year,  degree_name_eng: item?.degree_name_eng, degree_name: item?.degree_name, faculty_name_eng: obj?.faculty_name_eng, faculty_name: obj?.faculty_name
                                                                }
                                                            })

                                                        }} />

                                                    </Box>
                                                )
                                            }) : <Typography>{t('SET_TUITION_FEES_NO_DATA')}...</Typography>}

                                        </AccordionDetails>
                                    </Accordion>
                                )
                            })}

                        </Box>

                        <ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => {navigate(-1)},
                                    },
                                    key: "CANCEL",
                                    label: t("SET_TUITION_FEES_BACK"),
                                    type: "CANCEL"
                                },



                            ]}
                        />
                    </div>
                }
            />

        </div >
    )
}
